export default function PageTitle({ title, subtitle, action, testId }) {
  return (
    <div className="mb-2 flex flex-wrap items-end justify-between gap-3" data-testid={testId}>
      <div className="flex items-start gap-3">
        <span
          className="mt-1 h-10 w-1.5 flex-shrink-0 rounded-sm bg-primary sm:h-12"
          aria-hidden="true"
        />
        <div>
          <h1 className="font-display text-3xl font-bold uppercase leading-tight tracking-tight sm:text-4xl">
            {title}
          </h1>
          {subtitle && <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p>}
        </div>
      </div>
      {action && <div className="flex items-center gap-2">{action}</div>}
    </div>
  );
}
